<template>
  <div>
    <ul>
      <li
        v-for="(item, index) in framesList"
        :key="index"
        :style="item.checked ? framesActive : ''"
        @click="clickFrames(item, index)"
      >
        <div class="dot" :style="{ background: item.tagColor }" />
        <div v-show="!item.isEdit" class="left_tags_item">
          {{ item.framesName }}
        </div>
        <div class="new_tag" v-show="item.adMaterialDetail.isNew && !item.isEdit">
          new
        </div>
        <div v-show="!item.isEdit" class="icon_warpper">
          <a-icon
            type="edit"
            @click.stop="editFramesName(item, index)"
            v-if="!item.adMaterialDetail.isPlay && isEditProps"
          />
          <a-icon
            type="delete"
            @click.stop="handlerDelectFrames(index, index)"
            v-if="!item.adMaterialDetail.isPlay && isEditProps"
          />
        </div>
        <div v-show="item.isEdit" class="left_tags_item">
          <a-input
            v-model="item.framesName"
            :ref="'nameInputRef' + index"
            :autoFocus="item.isEdit"
          />
        </div>
        <div v-show="item.isEdit" class="text_warpper">
          <div class="save_name" @click.stop="handlerSavename(item, index)">保存</div>
          <div class="cancel_name" @click.stop="handlerCancelSetname(item, index)">取消</div>
        </div>
        <div class="check_box" v-show="item.adMaterialDetail.fullImageUrl">
          <a-icon type="check" />
        </div>
      </li>
    </ul>
    <div
      class="add_frames"
      @click="showSetName"
      v-show="framesList.length < 12 && isEditProps && priceStrategyProps == 1"
    >
      <a-icon type="plus" />新建画面
    </div>
    <a-modal
      class="set_name_modal"
      :width="288"
      v-model="visibleSetName"
      title="请输入新建画面名称"
      ok-text="确认"
      cancel-text="取消"
      @ok="setInitName"
      @cancel="handleCancelSetName"
    >
      <a-input v-model="newFramesName" placeholder="最长支持8个汉字" />
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { validateTextLength } from '../../../utils/utils'
export default {
  data() {
    return {
      framesColorList: [
        //画面的取色列表
        'rgba(24, 144, 255, 1)',
        'rgba(0, 240, 133, 1)',
        'rgba(250, 173, 20, 1)',
        'rgba(137, 122, 255, 1)',
        'rgba(21, 236, 229, 1)',
        'rgba(214, 131, 255, 1)',
        'rgba(255, 146, 84, 1)',
        'rgba(255, 72, 151, 1)',
        'rgba(185, 228, 0, 1)',
        'rgba(26, 190, 255, 1)',
        'rgba(255, 236, 0, 1)',
        'rgba(255, 50, 50, 1)'
      ],
      useColorList: [],
      noUseColorList: [],
      framesActive: {
        background: '#E6F7FF',
        border: '1px solid #1890FF'
      },
      visibleSetName: false, //是否展示设置名称页面
      newFramesName: '', //新建画面名称
      isEditProps: false,
      priceStrategyProps: 0 //轮播可以新建画面，精准不能新建
    }
  },
  props: {
    isEdit: Boolean,
    priceStrategy: Number
  },
  computed: {
    ...mapState(['framesList', 'isUpload'])
  },

  watch: {
    isEdit: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.isEditProps = newVal
      },
      immediate: true
    },
    priceStrategy: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.priceStrategyProps = newVal
      },
      immediate: true
    }
  },
  methods: {
    //删除画面  改变属性
    ...mapMutations(['delectFrames', 'changeAttribute']),
    handlerDelectFrames(index) {
      if (this.isUpload) {
        return this.$message.warning('正在上传物料,请勿删除画面')
      }
      if (this.framesList.length == 1) {
        return this.$message.warning('至少保留一个画面')
      }
      this.delectFrames(index)
    },
    //点击左侧画面
    clickFrames(item, index) {
      if (this.isUpload) {
        return this.$message.warning('正在上传物料,请勿切换画面')
      }
      this.$store.commit('checkedFrames', item)
    },

    //新增画面
    addFrames() {
      //id递增方法
      let newFrames = {
        framesName: '',
        lastFramesName: '',
        checked: false,
        isNew: true,
        tagColor: '',
        isEdit: false,
        playDates: [],
        adMaterialDetail: {}
      }
      //如果是唯一一个则新建完默认选中

      //弹窗设置名字
      newFrames.framesName = this.newFramesName
      newFrames.lastFramesName = this.newFramesName
      this.newFramesName = ''
      //这里要挑选颜色 排除已选的颜色 在未选择的颜色中选第一个
      this.checkColor()
      //如果颜色全部用完
      if (!this.noUseColorList[0]) {
        return this.$message.warning('最多存在12个画面')
      }
      newFrames.tagColor = this.noUseColorList[0]
      if (!this.framesList.length) {
        newFrames.checked = true
        this.$store.commit('checkedFrames', newFrames)
      }
      this.$store.commit('addFrames', newFrames)
    },
    //检测单前使用了哪些颜色，以及还剩下什么颜色
    verifyColor() {},
    //编辑画面名称
    editFramesName(item, index) {
      let that = this
      this.changeAttribute({ item, att: 'isEdit', value: true })
      this.$nextTick(() => that.$refs['nameInputRef' + index][0].focus())
    },
    //保存画面名称 修改
    handlerSavename(item, index) {
      if (this.validateNewName(item.framesName, index)) {
        this.changeAttribute({ item, att: 'isEdit', value: false })
        this.changeAttribute({
          item,
          att: 'lastFramesName',
          value: item.framesName
        })
      }
      //input双向绑定了vuex中的数据 待优化 在严格模式中，由于这个修改不是在 mutation 函数中执行的, 这里会抛出一个错误。
    },
    //取消编辑名称
    handlerCancelSetname(item) {
      // 在严格模式中，由于这个修改不是在 mutation 函数中执行的, 这里会抛出一个错误。
      this.changeAttribute({ item, att: 'isEdit', value: false })
      this.changeAttribute({
        item,
        att: 'framesName',
        value: item.lastFramesName
      })
    },
    //新建画面弹出层 确定
    setInitName() {
      //校验画面名称
      if (this.validateNewName(this.newFramesName)) {
        this.addFrames()
        this.visibleSetName = false
      }
    },
    //新建画面弹出层 取消
    handleCancelSetName() {
      this.visibleSetName = false
      this.newFramesName = ''
    },
    //弹出设置名称弹窗
    showSetName() {
      this.visibleSetName = true
    },
    // 初始化判断画面列表有哪些颜色被使用以及哪些颜色没被使用
    checkColor() {
      this.useColorList = []
      this.noUseColorList = []
      this.framesList.forEach(item => {
        this.useColorList.push(item.tagColor)
      })
      this.noUseColorList = this.framesColorList.filter(item => {
        return !this.useColorList.includes(item)
      })
    },
    //校验名称
    validateNewName(value, index = undefined) {
      //长度最多能八位 input自带限制
      if (validateTextLength(value) > 8) {
        this.$message.warning('最长输入八个汉字')
        return false
      }
      //验证是否是空
      if (!value.trim()) {
        this.$message.warning('不能为空')
        return false
      }
      //不能存在特殊字符
      let validate = "[`~!@#$^&*=|{}':;',\\[\\].<>/?~！@#……&*——|{}【】‘；：”“'。，、？]"
      for (let i = 0; i < value.length; i++) {
        const element = value[i]
        if (validate.indexOf(element) >= 0) {
          this.$message.warning('存在特殊字符')
          return false
        }
      }

      //编辑名字重名，要去掉自己的名字
      if (index != undefined) {
        let isReName = this.framesList.some((item, i) => {
          if (i != index) {
            item.lastFramesName == value && this.$message.warning('画面名称重复')
            return item.lastFramesName == value
          }
        })
        if (isReName) {
          return false
        }
      } else {
        //新建不能重名
        let isName = this.framesList.some(item => {
          item.lastFramesName == value && this.$message.warning('画面名称重复')
          return item.lastFramesName == value
        })
        if (isName) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  li {
    display: flex;
    position: relative;
    align-items: center;
    margin-bottom: 12px;
    border-radius: 4px;
    padding: 12px;
    width: 272px;
    height: 48px;
    cursor: pointer;
    border: 1px solid #f2f2f2;

    .dot {
      margin-right: 8px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: pink;
    }
    .new_tag {
      margin-left: 8px;
      text-align: center;
      width: 32px;
      height: 16px;
      background: #ff691e;
      border-radius: 2px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 16px;
    }
    .left_tags_item {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      .ant-input {
        width: 116px;
        height: 32px;
      }
    }
    .icon_warpper {
      // display: none;
      position: absolute;
      left: 169px;
      top: 50%;
      transform: translateY(-50%);
      height: 20px;
      display: none;
      color: #1890ff;
      .anticon {
        margin: 0 5px;
        height: 20px;
        width: 20px;
        font-size: 17px;
        line-height: 24px;
      }
    }
    &:hover .icon_warpper {
      display: block;
    }
    .text_warpper {
      display: flex;
      align-content: center;
      .save_name {
        padding: 0 8px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1890ff;
        line-height: 20px;
      }
      .cancel_name {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1890ff;
        line-height: 20px;
      }
    }
    .check_box {
      position: absolute;
      right: 14px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      background-color: #52c41a;
      border-radius: 50%;
      text-align: center;
      height: 20px;
      .anticon {
        font-size: 12px;
        color: #fff;
      }
    }
  }
}

.add_frames {
  width: 272px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid #f2f2f2;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
  user-select: none;
  /deep/ .anticon-plus {
    margin-right: 2px;
  }
}
// .set_name_modal {
//   .ant-modal-content {
//     width: 288px;
//   }
// }
</style>
